'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocationDisabled = function MdLocationDisabled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.1 29.2l-16.3-16.3c-1.5 1.9-2.4 4.4-2.4 7.1 0 6.5 5.1 11.6 11.6 11.6 2.7 0 5.2-0.9 7.1-2.4z m-22.1-22.1l2.1-2.1 27.9 27.9-2.1 2.1-3.4-3.4c-2.2 1.8-4.9 3-7.9 3.3v3.5h-3.2v-3.5c-7-0.8-12.5-6.3-13.3-13.3h-3.5v-3.2h3.5c0.3-3 1.5-5.7 3.3-7.9z m29.9 11.3h3.5v3.2h-3.5c-0.2 1.9-0.8 3.8-1.6 5.4l-2.5-2.5c0.5-1.4 0.8-2.9 0.8-4.5 0-6.5-5.1-11.6-11.6-11.6-1.6 0-3.1 0.3-4.4 0.8l-2.5-2.5c1.6-0.8 3.4-1.4 5.3-1.6v-3.5h3.2v3.5c7 0.8 12.5 6.3 13.3 13.3z' })
        )
    );
};

exports.default = MdLocationDisabled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/location-disabled.js
// module id = 3276
// module chunks = 0